import { cn } from '@/lib/cn';
import { type SVGProps } from 'react';

type HeidiProFlashFilledSvgProps = SVGProps<SVGSVGElement> & { alt?: string };

// Two-tone: the background recolours with the sky-blue override; the flash glyph stays white.
export const HeidiProFlashFilledSvg = ({
  alt = 'heidi pro flash filled',
  className,
  ...props
}: HeidiProFlashFilledSvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-tier-pro', className)}
      {...(alt ? { role: 'img', 'aria-label': alt } : { 'aria-hidden': true })}
      {...props}
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
        fill="currentColor"
      />
      <path
        d="M11.9839 8.46588C12.5263 8.46588 12.8085 9.11212 12.4395 9.50961L8.45509 13.8003C8.07097 14.2139 7.37867 13.9421 7.37842 13.3777V9.08699C7.37842 8.74395 7.6565 8.46596 7.99952 8.46588H11.9839ZM7.54468 2.19978C7.92887 1.78605 8.62135 2.0578 8.62135 2.6224V6.91308C8.62125 7.25602 8.34318 7.53409 8.00025 7.5342H4.01584C3.47353 7.5342 3.19154 6.88797 3.56027 6.49046L7.54468 2.19978Z"
        className="fill-text-primary-on-dark"
      />
    </svg>
  );
};
